<app-breadcrumb [master]="'Marketing'" [parentName]="'Stan magazynowy'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Dane">
    <app-warehouse-product-details-view
      *ngIf="!modify"
      [warehouseProduct]="warehouseProduct"
      (modifyClicked)="modify = true"
      (productChanged)="loadWarehouseProduct()">
    </app-warehouse-product-details-view>
    <app-warehouse-product-add *ngIf="modify" [warehouseProduct]="warehouseProduct" (closeModification)="modify = false; loadWarehouseProduct()"></app-warehouse-product-add>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [warehouseProduct]="warehouseProduct"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
